/* eslint-disable compat/compat */
class JoinWaitingList extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.listeners.add(this.els.form.element, 'submit', (e) => {
      e.preventDefault()
      this.onFormSubmission()
    })

    this.listeners.add(this.els.email.element, 'input', () => {
      this.handleSubmitButtonAction()
    })
  }

  onFormSubmission () {
    const variantId = this.els.form.element.dataset.variantId
    const emailAddress = this.els.email.element.value

    // Ensure only valid emails get submitted
    if (!emailAddress || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailAddress)) {
      console.error('❌ Invalid email detected:', emailAddress)
      alert('Please enter a valid email address.')
      return
    }

    this.KlaviyoSubmission(variantId, emailAddress)
  }

  async KlaviyoSubmission (variantId, emailAddress) {
    try {
      // **Step 1: Register for Waiting List Notifications**
      const backInStockRequest = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
        {
          method: 'POST',
          headers: {
            accept: 'application/json',
            revision: '2024-06-15',
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: emailAddress.trim(),
                    },
                  },
                },
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId}`,
                  },
                },
              },
            },
          }),
        },
      )

      if (!backInStockRequest.ok) {
        console.error('❌ Waiting List Subscription Failed')
        return
      }

      // **Step 2: Retrieve Existing Profile (Check Stored Variants)**
      const profileCheckRequest = await fetch(
        `https://a.klaviyo.com/client/profiles/?company_id=${window.theme.klaviyo.apiKey}&filter=equals(email,"${emailAddress.trim()}")`,
        {
          method: 'GET',
          headers: {
            accept: 'application/json',
            revision: '2024-06-15',
          },
        },
      )

      const rawProfileCheckResponse = await profileCheckRequest.text()

      if (profileCheckRequest.ok && rawProfileCheckResponse) {
        const profileCheckResponse = JSON.parse(rawProfileCheckResponse)
      }

      const profileUpdateRequest = await fetch(
        `https://a.klaviyo.com/client/profiles/?company_id=${window.theme.klaviyo.apiKey}`,
        {
          method: 'POST',
          headers: {
            accept: 'application/json',
            revision: '2024-06-15',
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            data: {
              type: 'profile',
              attributes: {
                email: emailAddress.trim(),
                properties: {
                  waiting_list_signup: true, // ✅ Set waiting list signup attribute
                },
              },
            },
          }),
        },
      )

      if (!profileUpdateRequest.ok) {
        console.error('❌ Profile Update Failed')
      } else {
        this.showSuccess()
      }
    } catch (error) {
      console.error('❌ Fetch Operation Error:', error)
    }
  }

  catch (error) {
    console.error('❌ Fetch Operation Error:', error)
  }

  showSuccess () {
    const successMessage = document.createElement('p')
    successMessage.className = 'frm-Form_ValidationText frm-Form_ValidationText-success fz-14_140'
    successMessage.setAttribute('data-join-waiting-list-el', 'success-message')
    successMessage.textContent = window.theme.klaviyo.waitinglistListSignUpSuccess
    this.els.form.element.appendChild(successMessage)

    this.resetForm()
  }

  resetForm () {
    this.els.email.element.value = ''
    this.els.submit.element.setAttribute('disabled', true)
  }

  handleSubmitButtonAction () {
    const email = this.els.email.element.value
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)

    if (isValidEmail) {
      this.els.submit.element.disabled = false
    } else {
      this.els.submit.element.disabled = true
    }
  }
}

if (!customElements.get('join-waiting-list')) {
  customElements.define('join-waiting-list', JoinWaitingList)
}
